import Reveal from "@/components/Reveal";
import { Truck, Package, Gauge } from "lucide-react";

const FLEET = [
  {
    img: "https://images.pexels.com/photos/14084957/pexels-photo-14084957.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    alt: "White Toyota HiAce van on a city street at night",
    pos: "object-bottom",
    name: "Refrigerated vans",
    spec: "1T payload",
    detail: "Nimble metro runners for urgent chilled courier work and tight CBD dock access.",
    testid: "fleet-card-vans",
  },
  {
    img: "https://images.pexels.com/photos/38199714/pexels-photo-38199714/free-photo-of-row-of-parked-isuzu-delivery-trucks-in-urban-area.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    alt: "Closed refrigerated pantech rigid truck at the depot",
    name: "Refrigerated Rigids",
    spec: "12T payload",
    detail: "The workhorses of the fleet — multi-drop routes across the metro with zone-controlled holds.",
    testid: "fleet-card-rigids",
  },
  {
    img: "https://images.unsplash.com/photo-1601584115197-04ecc0da31d7?q=85&w=940&auto=format&fit=crop",
    alt: "White refrigerated box truck ready for dispatch",
    name: "Refrigerated Containers & Semi's",
    spec: "32T payload",
    detail: "Refrigerated containers and semi-trailers for wharf-to-warehouse container moves, cold-store transfers and bulk frozen linehaul.",
    testid: "fleet-card-heavy",
  },
];

const Fleet = () => (
  <section id="fleet" data-testid="fleet-section" className="relative py-32 lg:py-40">
    <div className="max-w-[1440px] mx-auto px-6 lg:px-12">
      <Reveal className="flex flex-wrap items-end justify-between gap-8">
        <div>
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-frost font-bold mb-6 flex items-center gap-3">
            <span className="w-8 h-px bg-frost inline-block" />
            The fleet
          </p>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight uppercase font-medium">
            Built for the cold
          </h2>
        </div>
        <div className="flex items-center gap-8 font-mono text-xs uppercase tracking-[0.2em] text-mist">
          <span className="flex items-center gap-2">
            <Truck className="w-4 h-4 text-frost" strokeWidth={1.5} /> 28 vehicles
          </span>
          <span className="flex items-center gap-2">
            <Gauge className="w-4 h-4 text-frost" strokeWidth={1.5} /> Live telemetry
          </span>
          <span className="flex items-center gap-2">
            <Package className="w-4 h-4 text-frost" strokeWidth={1.5} /> Carton to pallet
          </span>
        </div>
      </Reveal>

      <div className="mt-20 grid md:grid-cols-3 gap-6">
        {FLEET.map((vehicle, i) => (
          <Reveal key={vehicle.name} delay={i * 0.12}>
            <article data-testid={vehicle.testid} className="group border border-white/10 bg-surface/40">
              <div className="relative h-72 overflow-hidden [clip-path:polygon(0_0,100%_0,100%_92%,0_100%)]">
                <img
                  src={vehicle.img}
                  alt={vehicle.alt}
                  loading="lazy"
                  className={`w-full h-full object-cover ${vehicle.pos || "object-center"} grayscale-[35%] group-hover:grayscale-0 group-hover:scale-105 transition-[transform,filter] duration-700 ease-out`}
                />
                <div className="absolute inset-0 bg-abyss/20 group-hover:bg-abyss/0 transition-colors duration-700" aria-hidden="true" />
                <span className="absolute top-4 left-4 bg-black/60 backdrop-blur-xl border border-white/10 font-mono text-[10px] uppercase tracking-[0.2em] text-frost px-3 py-2">
                  {vehicle.spec}
                </span>
              </div>
              <div className="p-8">
                <h3 className="font-display text-2xl font-medium tracking-tight">{vehicle.name}</h3>
                <p className="mt-4 text-mist font-light leading-relaxed text-sm">{vehicle.detail}</p>
              </div>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Fleet;
